module.exports = __webpack_public_path__ + "img/brand-drachei-big.9692e17b.svg";